import { AnyAction } from 'redux';
import {
  CreateOfferOrderCardPaymentIntentDto,
  UpdateOfferOrderDto,
  CreateOfferOrderCardPaymentIntentResponseDto,
  UpdateOfferOrderCardPaymentIntentDto,
  UpdateOfferOrderCardPaymentIntentResponseDto,
  GetOfferOrderDto,
  CancelOfferOrderDto,
  FailOfferOrderDto,
  GetOfferOrderListDto,
  CompleteOfferOrderDto,
} from 'src/dtos';
import { OfferOrderDetails, OfferOrderIntent } from 'src/models';

import { createAction, State, Type } from './utils';

export const offerOrdersGetListRequested = (payload: GetOfferOrderListDto): AnyAction =>
  createAction(State.actionRequested(Type.GET_OFFER_ORDERS), payload);

export const offerOrdersGetListSucceeded = (payload?: any): AnyAction =>
  createAction(State.actionSucceeded(Type.GET_OFFER_ORDERS), payload);

export const doGetOfferOrderDetails = (payload: GetOfferOrderDto): AnyAction =>
  createAction(State.actionRequested(Type.GET_OFFER_ORDER_DETAILS), payload);

export const doSucceededGetOfferOrderDetails = (payload: OfferOrderDetails): AnyAction =>
  createAction(State.actionSucceeded(Type.GET_OFFER_ORDER_DETAILS), payload);

export const doClearGetOfferOrderDetails = (): AnyAction =>
  createAction(State.actionCleared(Type.GET_OFFER_ORDER_DETAILS));

export const offerOrdersCreateRequested = (payload: OfferOrderIntent & { accountId: number }): AnyAction =>
  createAction(State.actionRequested(Type.CREATE_OFFER_ORDERS), payload);

export const offerOrdersCreateSucceeded = (payload?: any): AnyAction =>
  createAction(State.actionSucceeded(Type.CREATE_OFFER_ORDERS), payload);

export const clearCreateOfferOrder = (): AnyAction => createAction(State.actionCleared(Type.CREATE_OFFER_ORDERS));

export const doUpdateOfferOrder = (payload: UpdateOfferOrderDto): AnyAction =>
  createAction(State.actionRequested(Type.UPDATE_OFFER_ORDER), payload);

export const doSucceededUpdateOfferOrder = (payload: OfferOrderDetails): AnyAction =>
  createAction(State.actionSucceeded(Type.UPDATE_OFFER_ORDER), payload);

export const clearUpdateOfferOrder = (): AnyAction => createAction(State.actionCleared(Type.UPDATE_OFFER_ORDER));

export const doCancelOfferOrder = (payload: CancelOfferOrderDto): AnyAction =>
  createAction(State.actionRequested(Type.CANCEL_OFFER_ORDER), payload);

export const doSucceededCancelOfferOrder = (payload: OfferOrderDetails): AnyAction =>
  createAction(State.actionSucceeded(Type.CANCEL_OFFER_ORDER), payload);

export const doClearCancelOfferOrder = (): AnyAction => createAction(State.actionCleared(Type.CANCEL_OFFER_ORDER));

export const doFailOfferOrder = (payload: FailOfferOrderDto): AnyAction =>
  createAction(State.actionRequested(Type.FAIL_OFFER_ORDER), payload);

export const doSucceededFailOfferOrder = (): AnyAction => createAction(State.actionSucceeded(Type.FAIL_OFFER_ORDER));

export const doClearFailOfferOrder = (): AnyAction => createAction(State.actionCleared(Type.FAIL_OFFER_ORDER));

export const doFailFailOfferOrder = (payload: any): AnyAction =>
  createAction(State.actionFailed(Type.FAIL_OFFER_ORDER), payload);

export const doCompleteOfferOrder = (payload: CompleteOfferOrderDto): AnyAction =>
  createAction(State.actionRequested(Type.COMPLETE_OFFER_ORDER), payload);

export const doSucceededCompleteOfferOrder = (payload: OfferOrderDetails): AnyAction =>
  createAction(State.actionSucceeded(Type.COMPLETE_OFFER_ORDER), payload);

export const doClearCompleteOfferOrder = (): AnyAction => createAction(State.actionCleared(Type.COMPLETE_OFFER_ORDER));

export const doFailedCompleteOfferOrder = (payload: any): AnyAction =>
  createAction(State.actionFailed(Type.COMPLETE_OFFER_ORDER), payload);

export const addOfferOrderIntent = (payload: OfferOrderIntent) => createAction(Type.ADD_OFFER_ORDER_INTENT, payload);

export const removeOfferOrderIntent = () => createAction(Type.REMOVE_OFFER_ORDER_INTENT);

export const createOfferOrderCardPaymentIntent = (payload: CreateOfferOrderCardPaymentIntentDto) =>
  createAction(State.actionRequested(Type.CREATE_OFFER_ORDER_CARD_PAYMENT_INTENT), payload);

export const createOfferOrderCardPaymentIntentSucceeded = (payload: CreateOfferOrderCardPaymentIntentResponseDto) =>
  createAction(State.actionSucceeded(Type.CREATE_OFFER_ORDER_CARD_PAYMENT_INTENT), payload);

export const clearCreateOfferOrderCardPaymentIntent = () =>
  createAction(State.actionCleared(Type.CREATE_OFFER_ORDER_CARD_PAYMENT_INTENT));

export const updateOfferOrderCardPaymentIntent = (payload: UpdateOfferOrderCardPaymentIntentDto) =>
  createAction(State.actionRequested(Type.UPDATE_OFFER_ORDER_CARD_PAYMENT_INTENT), payload);

export const updateOfferOrderCardPaymentIntentSucceeded = (payload: UpdateOfferOrderCardPaymentIntentResponseDto) =>
  createAction(State.actionSucceeded(Type.UPDATE_OFFER_ORDER_CARD_PAYMENT_INTENT), payload);

export const updateOfferOrderCardPaymentIntentFailed = (payload: any) =>
  createAction(State.actionFailed(Type.UPDATE_OFFER_ORDER_CARD_PAYMENT_INTENT), payload);

export const submitCardPayment = () => createAction(State.actionRequested(Type.SUBMIT_CARD_PAYMENT));

export const clearSubmitCardPayment = () => createAction(State.actionCleared(Type.SUBMIT_CARD_PAYMENT));

export const confirmCardPayment = () => createAction(State.actionRequested(Type.CONFIRM_CARD_PAYMENT));

export const confirmCardPaymentSucceeded = () => createAction(State.actionSucceeded(Type.CONFIRM_CARD_PAYMENT));

export const confirmCardPaymentFailed = (payload: any) =>
  createAction(State.actionFailed(Type.CONFIRM_CARD_PAYMENT), payload);

export const clearConfirmCardPayment = () => createAction(State.actionCleared(Type.CONFIRM_CARD_PAYMENT));
